import React from "react";
import { Link } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../../Components/Footer/Footer";
const PrivacyPolicy = () => {
	return (
		<>
			<Header />
			<div className="min-h-screen bg-gray-50 px-4 py-10 sm:px-6 lg:px-16">
				{/* Container */}
				<div className="mx-auto max-w-5xl bg-white rounded-2xl shadow-md p-6 sm:p-10">

					{/* Title */}
					<h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
						Privacy Policy
					</h1>

					{/* Breadcrumb */}
					<p className="text-sm text-gray-500 mb-8">
						<Link to="/" className="hover:text-blue-600 transition-colors">
							Home
						</Link>
						<span className="mx-1">/</span>
						<span className="text-gray-700">Privacy Policy</span>
					</p>

					{/* Content */}
					<div className="space-y-6 text-gray-700 text-sm sm:text-base leading-relaxed">

						<p>
							This Privacy Policy describes how{" "}
							<span className="font-semibold">
								DIGITAL NIGHT OWL PRIVATE LIMITED
							</span>{" "}
							and its affiliates collect, use, share, protect, or otherwise process
							your personal data through our platform. By using this platform, you
							agree to be governed by the laws of India.
						</p>

						{/* Collection */}
						<h2 className="text-lg font-semibold text-gray-900">Collection</h2>
						<p>
							We collect personal data when you use our platform, register, or
							interact with us. This may include name, date of birth, address,
							contact details, identity proof, payment information, or biometric
							information (with consent), in accordance with applicable laws.
						</p>
						<p>
							You may choose not to provide certain information, but this may limit
							access to some services. We may also collect transaction-related and
							aggregated behavioral data.
						</p>

						{/* Usage */}
						<h2 className="text-lg font-semibold text-gray-900">Usage</h2>
						<p>
							We use your personal data to provide services, fulfill orders,
							enhance customer experience, resolve disputes, conduct research,
							prevent fraud, and inform you about offers, products, and updates.
						</p>

						{/* Sharing */}
						<h2 className="text-lg font-semibold text-gray-900">Sharing</h2>
						<p>
							We may share your personal data with group entities, affiliates,
							sellers, service providers, payment partners, logistics partners,
							and government authorities as required by law or for service
							delivery.
						</p>

						{/* Security */}
						<h2 className="text-lg font-semibold text-gray-900">
							Security Precautions
						</h2>
						<p>
							We adopt reasonable security practices to protect your data.
							However, transmission over the internet is not completely secure.
							Users are responsible for maintaining the confidentiality of their
							login credentials.
						</p>

						{/* Data Retention */}
						<h2 className="text-lg font-semibold text-gray-900">
							Data Deletion and Retention
						</h2>
						<p>
							You may delete your account via profile settings. We may retain
							certain data to comply with legal obligations, prevent fraud, or
							for legitimate business purposes.
						</p>

						{/* Rights */}
						<h2 className="text-lg font-semibold text-gray-900">Your Rights</h2>
						<p>
							You may access, correct, and update your personal data through the
							platform functionalities.
						</p>

						{/* Consent */}
						<h2 className="text-lg font-semibold text-gray-900">Consent</h2>
						<p>
							By using our platform, you consent to the collection and processing
							of your data as described in this Privacy Policy. You may withdraw
							consent by contacting the Grievance Officer.
						</p>

						{/* Changes */}
						<h2 className="text-lg font-semibold text-gray-900">
							Changes to this Privacy Policy
						</h2>
						<p>
							We may update this Privacy Policy periodically. Please review it
							regularly for changes. Significant updates will be communicated as
							required by law.
						</p>

					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default PrivacyPolicy;
